const appendParameter = ({
    key,
    value,
    parameters,
}: {
    key: string;
    value: string | number | boolean | null | undefined;
    parameters: URLSearchParams;
}) => {
    const isValidValue = value !== undefined && value !== null && !Number.isNaN(value) && value !== '';
    if (isValidValue) {
        parameters.append(key, String(value));
    }
};

export const queryParametersToString = (
    queryParameters: Record<string, string[] | number[] | string | number | boolean | null | undefined>
) => {
    const parameters = new URLSearchParams();
    Object.entries(queryParameters).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            appendParameter({ key, value: value.join(','), parameters });
            return;
        }
        appendParameter({ key, value, parameters });
    });
    return parameters.toString() ? `?${parameters.toString()}` : '';
};
